module.exports = "<div class=\"js-panel1 double-panels__panel\"></div> <div class=\"js-resizer double-panels__resizer\"></div> <div class=\"js-panel2 double-panels__panel\"></div>";


//////////////////
// WEBPACK FOOTER
// ../src/templates/splitPanel.hbs
// module id = 719
// module chunks = 0